<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1585AL1/images/e9781439631416_cover.jpg?1684229398845" alt="This image is the cover for the book Saginaw in Vintage Postcards, Postcard History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Saginaw in Vintage Postcards, Postcard History
      </h1>
      <p class="bookDescription body article font2">
        <p>Because of its excellent river system, Saginaw developed from an Indian village into a bustling lumber town. In its early days, investors came from eastern cities and became wealthy lumber barons. They built beautiful mansions, hotels, and public buildings while they also supported civic projects. Before consolidating, there were two cities: East Saginaw and Saginaw City, separated by the Saginaw River. Many German societies, schools, and churches were organized in the area, due to the large number of residents with a German heritage. The early residents survived fires, floods, and the end of the lumber boom. Other industries developed and the city continued to grow. The rare postcards that appear in this book depict many historical buildings, the two separate cities, the German influence, and the philanthropy of the lumber barons. Join author Roberta Morey on a journey through Saginaw's rich industrial and cultural history.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Roberta Morey
      </h2>
      
      <p class="authorDescription body article">Roberta Morey was born in Saginaw, attended Saginaw schools, and is a graduate of Michigan State University. She has been married for 46 years, and has three grown children and four grandchildren. She is now retired after teaching in Bay City and Saginaw elementary schools for 30 years.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ca9257e0